// Which data source the app starts with. Production (the firm's own domain) always runs live: real clients never see the
// synthetic demo, even with ?demo. Demo stays for local work, previews and tests, or when Supabase is not configured.
export const PRODUCTION_HOST = /(^|\.)your-virtualcpa\.com$/i;

export function runsLive(host: string, params: URLSearchParams, configured: boolean): boolean {
  if (!configured) return false;
  if (PRODUCTION_HOST.test(host)) return true;
  return !params.has("demo");
}
